import { SVGProps, Ref, forwardRef } from 'react';

export const SpeakerCrossOutlinedSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <g>
                <path
                    fillRule="evenodd"
                    clipRule="evenodd"
                    d="M4.949 7.503 4.5 7.5C.563 7.5 0 8.063 0 12s.563 4.5 4.5 4.5q.232 0 .449-.003 1.456.978 2.917 1.946l1.27.843c2.2 1.465 3.3 2.197 4.082 1.364S14 17.913 14 14.105v-4.21c0-3.808 0-5.712-.782-6.545-.783-.833-1.883-.1-4.083 1.364l-1.269.843c-.974.647-1.947 1.293-2.917 1.946m.539 7.187.466.314c.965.65 1.931 1.29 2.902 1.936q.637.422 1.277.848c.558.371 1.01.672 1.402.913q.284.175.486.284c.03-.16.063-.375.089-.658.088-.953.09-2.28.09-4.222v-4.21c0-1.941-.002-3.269-.09-4.222a7 7 0 0 0-.09-.658q-.2.109-.485.283c-.392.242-.844.543-1.402.914l-1.277.849c-.972.645-1.937 1.286-2.902 1.935l-.466.314-.563-.007L4.5 9.3c-.97 0-1.6.037-2.031.118-.279.053-.39.109-.422.129-.02.032-.076.143-.129.422-.08.43-.118 1.06-.118 2.031 0 .97.037 1.6.118 2.031.053.279.109.39.129.422.032.02.143.076.422.129.43.08 1.06.118 2.031.118q.222 0 .425-.003z"
                    fill="currentColor"
                />
                <path
                    d="m19.09 12-2.363 2.364L18 15.636l2.364-2.363 2.363 2.363L24 14.364 21.636 12 24 9.636l-1.273-1.272-2.363 2.363L18 8.364l-1.273 1.272z"
                    fill="currentColor"
                />
            </g>
        </g>
    </svg>
));
SpeakerCrossOutlinedSize24Glyph.displayName = 'SpeakerCrossOutlinedSize24Glyph';
